import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import Form from "assets/scripts/components/common/form/Form/Form";
import isEmpty from "assets/scripts/utils/isEmpty";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import TextAreaFormGroup from "assets/scripts/components/common/form/TextAreaFormGroup/TextAreaFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import AccountFormGroups from "assets/scripts/components/common/form/AccountFormGroups/AccountFormGroups";
function getErrors(value) {
    return {
        subject: isEmpty(value.subject) ? REQUIRED : getMaxLengthError(value.subject, 100),
        message: isEmpty(value.message) ? REQUIRED : null,
    };
}
const messages = defineMessages({
    submit: {
        id: "forms.contactSecure.submit",
        defaultMessage: "Send"
    },
    subjectLabel: {
        id: "forms.contactSecure.subject.label",
        defaultMessage: "Subject"
    },
    messageLabel: {
        id: "forms.contactSecure.message.label",
        defaultMessage: "Message"
    },
    accountsLabel: {
        id: "forms.contactSecure.accounts.label",
        defaultMessage: "Accounts Related to This Message"
    }
});
export default class ContactForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleSubjectChange = (subject) => this.setState({ subject });
        this._handleAccountChange = (accounts) => this.setState({ accounts });
        this._handleMessageChange = (message) => this.setState({ message });
        this.state = {
            subject: "",
            accounts: {},
            message: "",
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const errors = getErrors(state);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.contactSecure.legend" defaultMessage="Contact Information"/>
						</span>
					</legend>

					<TextFormGroup name="subject" label={messages.subjectLabel} value={state.subject} onChange={this._handleSubjectChange} error={errors.subject} backendError={backendErrors.subject} required/>

					<AccountFormGroups label={messages.accountsLabel} routeGroups={props.customFields} selectedIds={state.accounts} onChange={this._handleAccountChange} useRefNum/>

					<TextAreaFormGroup name="message" label={messages.messageLabel} value={state.message} onChange={this._handleMessageChange} error={errors.message} backendError={backendErrors.message} required/>
				</fieldset>
			</Form>);
    }
    _handleSubmit() {
        this.props.sendToAPI(this.state);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/ContactForm.tsx